import { publicApiRequest } from '../../../../lib/hooks/axios-instance'
import { addTokenToHeaders } from '../../../../lib/utils/addTokenReq'
import {
  GetIndividualResponseType,
  IndividualAccountsRequestType,
} from '../../../../types/individual.type'

export class IndividualService {
  /**
   * GET
   * Get list of individual accounts on super admin dashboard
   * @returns Promise<any>
   */
  public async getIndividualAccounts(data: IndividualAccountsRequestType) {
    return await (
      await publicApiRequest()
    ).get<GetIndividualResponseType>('auth/users/active-users', addTokenToHeaders(data.token))
  }

  /**
   * GET
   * Get all users from auth database (admin endpoint)
   * @returns Promise<any>
   */
  public async getAllAuthUsers(token: string) {
    return await (
      await publicApiRequest()
    ).get('auth/users/admin/all', addTokenToHeaders(token))
  }

  /**
   * GET
   * Get all users from profile database (admin endpoint)
   * @returns Promise<any>
   */
  public async getAllProfileUsers(token: string) {
    return await (
      await publicApiRequest()
    ).get('profile/admin/all', addTokenToHeaders(token))
  }

  /**
   * DELETE
   * Delete user from auth database permanently
   * @returns Promise<any>
   */
  public async deleteAuthUser(token: string, userId: string) {
    return await (
      await publicApiRequest()
    ).delete(`auth/users/admin/${userId}`, addTokenToHeaders(token))
  }

  /**
   * DELETE
   * Delete user from profile database permanently
   * @returns Promise<any>
   */
  public async deleteProfileUser(token: string, userId: string) {
    return await (
      await publicApiRequest()
    ).delete(`profile/admin/${userId}`, addTokenToHeaders(token))
  }
}
